import * as React from 'react';
import { Button, TextField, Select, MenuItem, FormControl, FormControlLabel, InputLabel, Switch } from '@material-ui/core';
import { IEquipment } from '../_types/location';

import { EnumToString } from '../_util/Utility';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Icon, { SupportedIcons } from '../common/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';

interface Props {
    classes: any;
    /** the item to display */
    item: IEquipment;
    /** raised when control is clicked */
    onSelect: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onCancel: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onSave: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onChange: (equip:IEquipment) => void;
    onDelete: (id: number | null) => void;
};

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    formWidth: {
        width: '44em',
        textAlign: "center",
    }
}));

const EquipmentDisplayItem: React.FC<Props> = (prop: Props) => {
    const classes = useStyles();
    const [deleteConfirmOpen, setDeleteConfirmDialog] = useState<boolean>(false);
    const [matchText, setMatchText] = useState<string>('');

    let ChangeMatchText = function (e: { target: { value: React.SetStateAction<string>; }; }) {
        setMatchText(e.target.value);
    }

    let CancelDelete = function (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        setDeleteConfirmDialog(false);  
        setMatchText('');
    }

    let SubmitDelete = function () {
        setDeleteConfirmDialog(false);
        setMatchText('');
        prop.onDelete(prop.item.id)
    }
    
    return (<>
        <Grid item>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <Button onClick={(evt) => prop.onSelect(evt)}>{prop.item.name}</Button>
                </Grid>
                <Grid item style={{ marginLeft: "3px" }}>
                    <Chip size="small" 
                        color="primary" 
                        variant="outlined" 
                        label={EnumToString(prop.item.equipment_type_cn || "")} />
                </Grid>
                <Grid item>{prop.item.selected && 
                    (<IconButton size="small"
                        onClick={(e) => { prop.item.editing = true; 
                        prop.onChange(prop.item) }}>
                        <Icon fontSize="small" iconName={SupportedIcons.Edit} />
                    </IconButton>)}
                </Grid>
            </Grid>
        </Grid>
        
        <Dialog className={classes.formControl} open={deleteConfirmOpen}>
            <DialogTitle className={classes.formWidth}>Delete Confirmation</DialogTitle>
            <DialogContent>
                <div> 
                    Please enter the name of the equipment to confirm deletion <b> &#40;{prop.item.name}&#41; </b>
                </div>
                <TextField id="matchText" 
                    label="Equipment Name" 
                    value={matchText} 
                    onChange={ChangeMatchText} />
            </DialogContent>
            <DialogActions>
                <Button onClick={(event) => CancelDelete(event)}>Cancel</Button>
                <Button onClick={SubmitDelete} 
                    disabled={matchText.toLowerCase() !== prop.item.name?.toLowerCase()}>Confirm</Button>
            </DialogActions>
        </Dialog>

        {prop.item.editing && (
            <Dialog className={classes.formControl} open={prop.item.editing}>
                <DialogTitle className={classes.formWidth}>Add/Edit Equipment</DialogTitle>
                <DialogContent>
                    <Grid container direction="column">
                        <Grid item>
                            {/* name, type, enabled, save, cancel */}
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <TextField label="Name" 
                                        value={prop.item.name} 
                                        onChange={(e) => { let i = prop.item; i.name = e.target.value; 
                                        prop.onChange(i) }}></TextField>
                                </Grid>
                                <Grid item>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel id="type-select-label">Type</InputLabel>
                                        <Select
                                            labelId="type-select-label"
                                            id="type-select"
                                            value={prop.item.equipment_type_cn}
                                            onChange={(e) => { let i = prop.item; i.equipment_type_cn = e.target.value as string; prop.onChange(i) }}>
                                            <MenuItem value="equipmenttype.iba">{EnumToString("equipmenttype.iba")}</MenuItem>
                                            <MenuItem value="equipmenttype.tunnel">{EnumToString("equipmenttype.tunnel")}</MenuItem>
                                            <MenuItem value="equipmenttype.selfserve">{EnumToString("equipmenttype.selfserve")}</MenuItem>
                                            <MenuItem value="equipmenttype.vac">{EnumToString("equipmenttype.vac")}</MenuItem>
                                            <MenuItem value="equipmenttype.dispenser">{EnumToString("equipmenttype.dispenser")}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item>
                                    <FormControlLabel control={
                                        <Switch checked={prop.item.enabled} onChange={(e) => { let i = prop.item; i.enabled = e.target.checked; prop.onChange(i) }}></Switch>
                                    }
                                        label="Enabled" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={prop.onCancel}>Cancel</Button>
                    <Button onClick={() => setDeleteConfirmDialog(true)}>Delete</Button>
                    <Button onClick={prop.onSave}>Save</Button>
                </DialogActions>
            </Dialog>
        )}
    </>);
}

export default EquipmentDisplayItem;